// GST Type Listing
global.blogCatgeoryList = global.API_ADMIN_URL+'blogCatgeoryList/';
global.adminAddBlogCatgeory = global.API_ADMIN_URL+'adminAddBlogCatgeory/';
global.adminEditBlogCatgeory = global.API_ADMIN_URL+'adminEditBlogCatgeory/';
global.blogCatgeoryDetails = global.API_ADMIN_URL+'blogCatgeoryDetails/';